import React from "react";
import styled from "styled-components";
import { ReactComponent as DeleteIcon } from "@/assets/upload/delete_icon.svg?react";

const ProgressBarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 16px;
`;

const DeleteButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ProgressBarContainer = styled.div`
  width: 100%;
  height: 4px;
  background-color: #e5e7eb;
`;

const ProgressBarFill = styled.div<{ $percent: number }>`
  width: ${(props) => props.$percent}%;
  height: 100%;
  background-color: #4b5eff;
  transition: width 0.3s ease;
`;

interface ProgressBarProps {
  percent: number;
  onCancel: () => void;
}

const ProgressBar: React.FC<ProgressBarProps> = React.memo(
  ({ percent, onCancel }) => (
    <ProgressBarWrapper>
      <ProgressBarContainer>
        <ProgressBarFill $percent={percent} />
      </ProgressBarContainer>
      <DeleteButton onClick={onCancel}>
        <DeleteIcon />
      </DeleteButton>
    </ProgressBarWrapper>
  )
);

ProgressBar.displayName = "ProgressBar";

export default ProgressBar;
